import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StartCeate.css';

function StartCeate({teacherId}) {
  const navigate = useNavigate();

  const handleViewClass = () => {
    navigate('/about');
  };

  const handleCreateClass = () => {
    navigate('/teacher-createClass', {
      state: {
        teacherId: teacherId,
      }
    });
  };

  const handleViewSession = () => {
    navigate('/about');
  };

  const handleCreateSession = () => {
    navigate('/about');
  };

  return (
    <div className='start-create'>
      <h4 className='create-class-title'>Start to Create</h4>
      <div className='create-class-container'>
        <div className='create-class-container-titles'>
          <span className='create-class-title'>Create a New Class</span>
          <span className='create-class-text-purple'>Need help to create your class?</span>
        </div>
        <div className='create-class-container-button'>
          <span className='create-class-button' onClick={handleViewClass}>View Classes</span>
          <span className='create-class-button-green' onClick={handleCreateClass}>Create a class</span>
        </div>
      </div>
      <div className='Session-create'>
        <div className='create-class-container'>
          <div className='create-class-container-titles'>
            <span className='create-class-title'>Create a New Live Session</span>
            <span className='create-class-text-purple'>Need help to create Live Session?</span>
          </div>
          <div className='create-class-container-button'>
            <span className='create-class-button' onClick={handleViewSession}>View Session</span>
            <span className='create-class-button-green' onClick={handleCreateSession}>Create Session</span>
          </div>
        </div>
      </div>
      <div className='create-class-container-titles'>
        <span className='create-class-under'>Learn Film production and sound enhancement tools</span>
        <span className='create-class-text-purple'>Here get started with video production?</span>
      </div>
    </div>
  );
}

export default StartCeate;